<!--
File Name          : choose-unit.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->
<div class="component-container">
    <div class="remaining-container">
        <div class="lessons-card standard-center-card">
            <img *ngIf="!screenservice.isMobile" width="320" height="80" src="/assets/branding/secondary_logo.svg" alt="Datasnap">
            <div class="standard-card-message">Select An Experience:</div>
            <dx-button *ngFor="let lesson of lessons" [icon]="lesson.iconPath" class="unit-button" [text]="lesson.title" type="default" (onClick)="openLesson(lesson)"></dx-button>
            <!-- <dx-button text="Air Racer" height="72px" width="100%" style="font-size: 36px; margin: 8px 0;" type="default"></dx-button>
            <dx-button text="Catapult" height="72px" width="100%" style="font-size: 36px; margin: 8px 0;" type="default"></dx-button> -->
            
        </div>
    </div>
</div>